import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import { installAuthGuard, router } from './router/index.ts';
import { browserLanguage, setLocale, storedLocale } from './i18n/index.ts';
import './assets/main.css';

// Before anything renders. The auth guard corrects this to the signed-in
// user's language a moment later, but a visitor who never signs in would
// otherwise read an English sign-in page on a Thai browser.
//
// A stored choice comes first: somebody who pressed ไทย in the header meant
// it, and meant it more than whatever their browser was shipped set to.
setLocale(storedLocale() ?? browserLanguage());

const app = createApp(App);

// Pinia first: the navigation guard reads the auth store, so the store must
// be available before the router starts resolving routes.
app.use(createPinia());
installAuthGuard();
app.use(router);

/**
 * Wait for the router before mounting.
 *
 * Mounting immediately paints one frame with the initial route *and no
 * session*, because the guard that restores it has not finished. The shell
 * then re-renders with the sidebars — so every page load visibly jumped: the
 * rails appeared and shoved the centre column sideways.
 *
 * `isReady()` resolves once the first navigation, guards included, has
 * settled. The first paint is then already correct.
 */
await router.isReady();

app.mount('#app');
